<template>
  <div>
    <el-dialog
      title="营销效果分析"
      :visible.sync="viewVisibleAnay"
      :before-close="handleClose"
      width="1300px"
      custom-class="dialog-box"
    >
      <el-form
        :model="formData"
        :inline="true"
        label-width="80px"
        ref="form"
        class="analysis-box"
      >
        <el-form-item label="分析批次">
          <el-select
            v-model="formData.outerId"
            @change="switchSendTime"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in batchList"
              :key="index"
              :label="item.sendTime"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" label-width="80">
          <el-select v-model="formData.flag" placeholder="请选择">
            <el-option
              v-for="(item, index) in flagList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="统计时间">
          <el-select
            placeholder="请选择"
            v-model="formData.type"
            @change="switchType"
            style="width: 140px; margin-right: 12px; vertical-align: top"
          >
            <el-option
              v-for="item in timeType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="formData.startTime"
              type="date"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="formData.endTime"
              type="date"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="false"
            ></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <el-button
            type="plain"
            :style="{ color: globalBG, 'border-color': globalBG }"
            style="margin-left: 20px"
            @click="handleSearch"
          >
            <i
              class="el-icon-search"
              style="
                display: inline-block;
                width: 14px;
                height: 12px;
                margin-top: -10px;
              "
            ></i>
            查询</el-button
          >
          <el-button @click="exportData">导出</el-button>
        </el-form-item>
      </el-form>
      <div class="tab_item_box_one">
        <el-tabs v-model="activeType" @tab-click="handleClick">
          <el-tab-pane label="效果统计" name="0"></el-tab-pane>
          <el-tab-pane label="TOP100商品分析" name="1"></el-tab-pane>
          <!-- <el-tab-pane label="加购商品top10" name="2"></el-tab-pane>
          <el-tab-pane label="付款商品top10" name="3"></el-tab-pane> -->
        </el-tabs>
      </div>
      <!-- 效果统计 -->
      <div v-if="+activeType === 0">
        <!-- 分析数据 -->
        <div class="effect-content">
          <div
            class="effect-item"
            v-for="(item, index) in effectList"
            :key="index"
            :style="{ width: item.title == '会员购买分析' ? '270px' : '250px' }"
          >
            <div class="title">{{ item.title }}</div>
            <div class="content">
              <p v-for="(eItem, eIndex) in item.dataList" :key="eIndex">
                {{ eItem.name }} {{ eItem.value ? eItem.value : "--" }}
                {{ eItem.unit }}
              </p>
            </div>
          </div>
        </div>

        <!-- 趋势分析 -->
        <div class="trend-analysis">
          <div class="title-line"><span>趋势分析</span></div>
          <div class="trend-wrap">
            <div class="trend-box-x">
              <div
                class="trend-item"
                v-for="(item, index) in trendingListX"
                :key="index"
              >
                <div class="type-title">{{ item.title }}</div>
                <div class="trend-radio">
                  <template v-for="(trendItem, trendIndex) in item.data">
                    <el-radio
                      :style="{
                        width: index != '3' ? '170px' : '240px',
                        'margin-right': '0',
                      }"
                      @change="getTrendValue(trendItem)"
                      :key="trendIndex"
                      v-model="trendKey"
                      :label="trendItem.key"
                    >
                      <span style="color: #666">{{ trendItem.name }}</span>
                    </el-radio>
                  </template>
                </div>
              </div>
            </div>
            <div class="trend-box">
              <div class="echart-box">
                <echarts
                  :legendShow="false"
                  :key="trendKey"
                  :seriesData="seriesData"
                  :echartsDate="echartsDate"
                ></echarts>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="+activeType === 1">
        <div style="margin: 16px 0;">
          <span>排序规则：</span>
          <el-select
            key="collationValue"
            v-model="collationValue"
            style="width: 208px;"
            @change="selectChange"
            placeholder="请选择">
            <el-option
              v-for="item in collationList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tip-box">
          <i class="el-icon-warning warning-icon"></i>
          <el-popover
            placement="bottom-start"
            title=""
            width="380"
            trigger="hover"
            content="列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100"
          >
            <span style="color: #333" slot="reference"
              >列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100</span
            >
          </el-popover>
        </div>
        <el-table
          ref="goodsTable"
          :data="topGoods"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          tooltip-effect="light"
          style="width: 100%; border: 1px solid #eee"
          stripe
          v-loading="tableLoading"
          max-height="650"
        >
          <el-table-column label="序号" width="50px">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="商品信息" width="240px">
            <template slot-scope="scope">
              <div class="goods-box">
                <img :src="scope.row.picUrl" alt="" />
                <div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.skuName"
                    placement="right"
                  >
                    <p class="shop-title">
                      {{ scope.row.skuName }}
                    </p>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="'skuid:' + scope.row.skuId"
                    placement="right"
                  >
                    <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="browsePv" min-width="90px" label="浏览PV(次数)">
              <template slot-scope="scope">
                <span>{{ scope.row.browsePv > 0 ? scope.row.browsePv : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="browseUv" min-width="90px" label="浏览UV(人数)">
              <template slot-scope="scope">
                <span>{{ scope.row.browseUv > 0 ? scope.row.browseUv : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cartUserNum" label="加购人数">
              <template slot-scope="scope">
                <span>{{ scope.row.cartUserNum > 0 ? scope.row.cartUserNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cartSkuNum" label="加购件数">
              <template slot-scope="scope">
                <span>{{ scope.row.cartSkuNum > 0 ? scope.row.cartSkuNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payUserNum" label="付款人数">
              <template slot-scope="scope">
                <span>{{ scope.row.payUserNum > 0 ? scope.row.payUserNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="paySkuNum" label="付款件数">
              <template slot-scope="scope">
                <span>{{ scope.row.paySkuNum > 0 ? scope.row.paySkuNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payAmount" label="付款金额">
              <template slot-scope="scope">
                <span>{{ scope.row.payAmount > 0 ? scope.row.payAmount : '/' }}</span>
              </template>
            </el-table-column>
        </el-table>
      </div>

      <!-- 浏览商品top10 -->
      <!-- <el-table
        v-if="+activeType === 1"
        ref="goodsTable"
        sum-text="合计"
        show-summary
        :data="browseGoods"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        tooltip-effect="light"
        style="width: 100%; border: 1px solid #eee"
        stripe
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods-box">
              <img :src="scope.row.picUrl" alt="" />
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.wareName"
                  placement="right"
                >
                  <p class="shop-title">
                    {{ scope.row.wareName }}
                  </p>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="'skuid:' + scope.row.skuId"
                  placement="right"
                >
                  <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          prop="pv"
          sortable
          label="PV(次数)"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="uv"
          sortable
          label="UV(人)"
        ></el-table-column>
      </el-table> -->
      <!-- 加购商品top10 -->
      <!-- <el-table
        v-if="+activeType === 2"
        ref="goodsTable"
        sum-text="合计"
        show-summary
        :data="cartGoods"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        tooltip-effect="light"
        style="width: 100%; border: 1px solid #eee"
        stripe
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods-box">
              <img :src="scope.row.picUrl" alt="" />
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.wareName"
                  placement="right"
                >
                  <p class="shop-title">
                    {{ scope.row.wareName }}
                  </p>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="'skuid:' + scope.row.skuId"
                  placement="right"
                >
                  <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="200px"
          prop="userNum"
          sortable
          label="加购人数"
        ></el-table-column>
        <el-table-column
          width="200px"
          prop="skuNum"
          sortable
          label="加购件数"
        ></el-table-column>
      </el-table> -->
      <!-- 付款商品top10 -->
      <!-- <el-table
        ref="goodsTable"
        sum-text="合计"
        v-if="+activeType === 3"
        show-summary
        :data="payGoods"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        tooltip-effect="light"
        style="width: 100%; border: 1px solid #eee"
        stripe
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods-box">
              <img :src="scope.row.picUrl" alt="" />
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.wareName"
                  placement="right"
                >
                  <p class="shop-title">
                    {{ scope.row.wareName }}
                  </p>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="'skuid:' + scope.row.skuId"
                  placement="right"
                >
                  <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          prop="userNum"
          sortable
          label="付款人数"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="skuNum"
          sortable
          label="付款件数"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="amount"
          sortable
          label="付款金额"
        ></el-table-column>
      </el-table> -->
    </el-dialog>
    <!-- 生成报表 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1 = 'getphone1'
    ></generate>
    <!-- 修改名称弹框 -->
    <el-dialog title="短信分析" v-if="showHide" :visible.sync="viewVisible" :close-on-click-modal="false" @close="close1" width="548px">
      <div class="form-tip-box">
        <img
          src="@/assets/images/new_icon_waring_yellow.png"
          class="form-tip-box-icon"
        />
        <span style="margin-left: 24px; color: #333">您还未开始营销，请在短信发送后可看营销效果</span>
      </div>
      <el-form :model="shortForm" :rules="rules1" ref="ruleForm1" :disabled="isReadOnly" :label-width="formLabelWidth1">
        <el-form-item label="节点名称" prop="name">
          <el-input v-model="shortForm.name" 
                  autocomplete="off"       
                  :maxlength="50"
                  show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" :disabled="isReadOnly" @click="shortSubmit">确 定</el-button>
    </div>
  </el-dialog>












  </div>
</template>

<script>
import { mapState } from "vuex";
import { getSmsRecordDown } from "@/api/intelligentMarket/index";
import { getOfficialData } from "@/api/smsMarketing";
import echarts from "@/components/echarts.vue";
import { officialExport } from "@/api/sellerController";
import generate from "../../components/generate_report.vue";
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: "smsAnalysis",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //升级
      showHide:false,
      formLabelWidth1:'90px',
      rules1: {
        name: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      },
      shortForm:{
        name:""
      },
      viewVisibleAnay:false,
      control:false,
      sendTime: "",
      formData: {
        flag: "",
        outerId: "",
        type: "",
        startTime: "",
        endTime: "",
      },
      activeType: "0",
      beanType: 0, // 趋势类型
      flagList: [
        {
          label: "汇总",
          value: "",
        },
        {
          label: "触达",
          value: "0",
        },
        {
          label: "点击",
          value: "1",
        },
      ],
      batchList: [],
      timeType: [
        {
          label: "自定义",
          value: "",
        },
        {
          label: "近3天",
          value: "3",
        },
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
      ],
      browseGoods: [], // 浏览商品
      cartGoods: [], // 加购商品
      payGoods: [], // 付款商品
      topGoods: [], // top100
      seriesData: [], // 图标所需的趋势分析数据
      echartsDate: [],
      effectList: [], // 效果分析数据

      tableLoading: false,
      shopMemberType: "",
      trendKey: "",
      trendingListX: [],
      collationValue: "payUserNum", // 排序规则
      collationList: [
        { label: '按浏览PV（次数）', value: 'browsePv'},
        { label: '按浏览UV（人数）', value: 'browseUv'},
        { label: '按加购人数', value: 'cartUserNum'},
        { label: '按加购件数', value: 'cartSkuNum'},
        { label: '按付款人数', value: 'payUserNum'},
        { label: '按付款件数', value: 'paySkuNum'},
        { label: '按付款金额', value: 'payAmount'},
      ], // 排序选项
    };
  },
  watch: {
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
      }
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
    viewVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  created(){
    mnode
      .getNode({
        nodeId: this.nodeId 
      })
      .then(res=>{
        this.shortForm.name = res.data.name })
    this.showHide = true  //升级-----判断修改名称弹框显示隐藏
    let fors = sessionStorage.getItem('analyzestatus') //升级-------判断运行状态
    if(fors== 0 || fors== 4){
      this.viewVisibleAnay = false
      this.showHide = true
    }else{
      this.viewVisibleAnay = true
      this.showHide = false
    }

  },
  mounted() {
    this.shopMemberType = this.shopInfo.shopMemberType;
    var id = this.nodeId;
    // var id = 5;
    if(this.viewVisibleAnay){
      getSmsRecordDown(id).then((res) => {
      this.batchList = res.data || [];
      if (this.batchList.length > 0) {
        var outerId = this.batchList[0].id;
        this.formData.outerId = outerId;
        this.switchSendTime(outerId);
        this.getEffectData();
      }
     });
    }
  },
  methods: {
    //升级
    close1(){
      this.viewVisibleAnay = false;
    },
   //升级修改名称事件
    shortSubmit () {
      this.$refs.ruleForm1.validate((valid) => {
        if (valid) {
          let data = this.getDataify()
          mnode.updateDetail(data).then(res => {
            if (res.code === 1) {
              this.$message.success(res.message)
              this.viewVisible = false
              this.$emit('change-name', data)
            }
          })
        } else {
          return false
        }
      })
    },
    getDataify () {
      let formData = {}
      formData.nodeId = this.$props.nodeId
      formData.name = this.shortForm.name
      return formData
    },
    getTrendValue(item) {
      // console.log("item", item);
      var key = item.key;
      var tendencyList = this.effectData.tendencyList;
      if (!tendencyList) {
        // 空数据给默认
        this.seriesData = [
          {
            name: item.name,
            data: [0, 0],
          },
        ];
        this.echartsDate = [this.formData.startTime, this.formData.endTime];
        return;
      }
      var dataList = [];
      var echartsDate = [];
      tendencyList.forEach((item) => {
        dataList.push(item[key]);
        echartsDate.push(item.effectDate);
      });
      this.echartsDate = echartsDate;
      this.seriesData = [
        {
          name: item.name,
          data: dataList,
        },
      ];
    },
     getTendencyList() {
      var tendencyMap = [
        {
          title: "流量趋势",
          data: [
            {
              key: "pv",
              name: "短链接点击PV",
            },
            {
              key: "uv",
              name: "短链接点击UV",
            },
            {
              key: "skuPvNum",
              name: "商品详情页PV",
            },
            {
              key: "skuUvNum",
              name: "商品详情页UV",
            },
            {
              key: "shopPvNum",
              name: "店铺首页PV",
            },
            {
              key: "shopUvNum",
              name: "店铺首页UV",
            },
          ],
        },
        {
          title: "转化趋势",
          data: [
            {
              key: "ordPins",
              name: "下单人数",
            },
            {
              key: "ordAmount",
              name: "下单金额",
            },
            {
              key: "ordNum",
              name: "下单订单数",
            },
            {
              key: "ordQtty",
              name: "下单件数",
            },
            {
              key: "payPins",
              name: "付款人数",
            },
            {
              key: "payAmount",
              name: "付款金额",
            },
            {
              key: "payNum",
              name: "付款订单数",
            },
            {
              key: "payQtty",
              name: "付款件数",
            },
          ],
        },
        {
          title: "兴趣趋势",
          data: [
            {
              key: "followSkuNum",
              name: "关注商品人数",
            },
            {
              key: "followShopNum",
              name: "关注店铺人数",
            },
            {
              key: "cartNum",
              name: "加购人数",
            },
          ],
        },
        {
          title: "会员趋势",
          data: [
            {
              key: "memberBuyPins",
              name: "已购会员购买客户数",
            },
            {
              key: "brandMemberBuyPins",
              name: "品牌开卡会员购买客户数",
            },
            {
              key: "brandMemberNewBuyPins",
              name: "品牌开卡会员购买新客户数",
            },
            {
              key: "cardMemberBuyPins",
              name: "店铺开卡会员购买客户数",
            },
            {
              key: "cardMemberNewBuyPins",
              name: "店铺开卡会员购买新客户数",
            },
          ],
        },
      ];
      var shopMemberType = this.shopMemberType; 
      if (shopMemberType == "2" || shopMemberType == "4") {
        // 显示店铺开卡会员
        tendencyMap[3].data.splice(1, 2);
      } else if (shopMemberType == "3" || shopMemberType == "5") {
        // 显示品牌开卡会员
        tendencyMap[3].data.splice(3, 2);
      }
      this.trendingListX = tendencyMap;
      var firstItem = tendencyMap[0].data[0];
      this.trendKey = firstItem.key;
      this.getTrendValue(firstItem)
    },
    exportData(){
      this.buriedPoint(9,'导出','','')
      this.control = true;
      console.log("control",this.control);
    },
    getphone1(val) {
      var param = {
        outerId: this.formData.outerId,
        source: "INTELLIGENT_MARKETING",
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        exportType:"智能营销",
        exportRemark:val,
        // flag: this.flag,
      };
      var paramStr = "";
      for (var key in param) {
        var temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);

      officialExport(paramStr).then((res)=>{
         if(res.code == 1){
          this.control = true
         }else{
          this.$message.error(res.message)
         }
      })
    },
    switchSendTime(id) {
      var sendTime = this.batchList.filter((item) => item.id == id)[0].sendTime;
      this.sendTime = sendTime;
      this.formData.type = "7";
      this.switchType(7);
    },
    switchType(val) {
      val--;
      var startTime = "";
      startTime = this.sendTime.substr(0, 10);
      this.formData.startTime = startTime;

      var dd = new Date(startTime);
      dd.setDate(dd.getDate() + +val);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      var endTime = y + "-" + m + "-" + d;
      this.formData.endTime = endTime;
    },

    getEffectData() {
      var param = {
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        flag: this.formData.flag,
        outerId: this.formData.outerId,
        source: "INTELLIGENT_MARKETING",
      };

      getOfficialData(param).then((res) => {
        if (res.code == "1") {
          var effectData = res.data;
          this.effectData = effectData;
          this.roi = effectData.roi;
          // this.browseGoods = JSON.parse(effectData.skuBrowsePvUvTop) || [];
          // this.cartGoods = JSON.parse(effectData.skuCartListTop) || [];
          // this.payGoods = JSON.parse(effectData.skuPayListTop) || [];
          this.topGoods = effectData.skuTopVos || [];
          if(this.$refs.goodsTable) {
            this.$refs.goodsTable.sort('payUserNum','descending');
          }
          this.encapEffect(effectData);
          // this.getSeriesData();
          this.getTendencyList();
        }
      });
    },

    getSeriesData() {
      // 流量趋势
      // debugger
      if (this.beanType == "0") {
        var flowTendency = this.effectData.flowTendencyList;
        if (flowTendency && flowTendency.length > 0) {
          var dateList = [],
            shopList = [],
            skuList = [],
            uvList = [];
          flowTendency.forEach((item, index) => {
            dateList.push(item.effectDate);
            shopList.push(item.shopUvNum);
            skuList.push(item.skuUvNum);
            uvList.push(item.uv);
          });
          this.echartsDate = dateList;
          this.seriesData = [
            {
              name: "店铺首页UV",
              data: shopList,
            },
            {
              name: "商品详情UV",
              data: skuList,
            },
            {
              name: "短链接访问UV",
              data: uvList,
            },
          ];
        }
      } else if (this.beanType == "1") {
        // 转化趋势
        var conTendency = this.effectData.conversionTendencyList;
        if (conTendency && conTendency.length > 0) {
          var dateList = [],
            followShopList = [],
            followSku = [],
            cartList = [],
            ordList = [],
            payList = [];

          conTendency.forEach((item, index) => {
            dateList.push(item.effectDate);
            followShopList.push(item.followShopNum);
            followSku.push(item.followSkuNum);
            cartList.push(item.cartNum);
            ordList.push(item.ordPins);
            payList.push(item.payPins);
          });
          this.echartsDate = dateList;
          this.seriesData = [
            {
              name: "关注店铺人数",
              data: followShopList,
            },
            {
              name: "关注商品人数",
              data: followSku,
            },
            {
              name: "加购人数",
              data: cartList,
            },
            {
              name: "下单人数 ",
              data: ordList,
            },
            {
              name: "付款人数",
              data: payList,
            },
          ];
        }
      } else if (this.beanType == "2") {
        // 会员趋势
        var memberTendency = this.effectData.memberTendencyList;
        if (memberTendency && memberTendency.length > 0) {
          var dateList = [],
            brandBuyPins = [],
            brandNewBuyPins = [],
            cardBuyPins = [],
            cardNewBuyPins = [],
            menberBuyPins = [];

          memberTendency.forEach((item, index) => {
            dateList.push(item.effectDate);
            brandBuyPins.push(item.brandMemberBuyPins);
            brandNewBuyPins.push(item.brandMemberNewBuyPins);
            cardBuyPins.push(item.cardMemberBuyPins);
            cardNewBuyPins.push(item.cardMemberNewBuyPins);
            menberBuyPins.push(item.memberBuyPins);
          });
          this.echartsDate = dateList;
          this.seriesData = [
            {
              name: "品牌开卡会员购买客户数",
              data: brandBuyPins,
            },
            {
              name: "品牌开卡会员购买新客户数",
              data: brandNewBuyPins,
            },
            {
              name: "店铺开卡会员购买客户数",
              data: cardBuyPins,
            },
            {
              name: "店铺开卡会员购买新客户数",
              data: cardNewBuyPins,
            },
            {
              name: "已购会员购买客户数",
              data: menberBuyPins,
            },
          ];
          var shopMemberType = this.shopMemberType;
          if (shopMemberType == "2" || shopMemberType == "4") {
            this.seriesData.splice(0, 2);
          } else if (shopMemberType == "3") {
            this.seriesData.splice(2, 2);
          }
        }
      }
    },

    // 效果分析数据封装
    encapEffect(data) {
      // 触达分析
      var targetCustomerMap = [
        {
          name: "预计触达人数：",
          value: data.sendSubmitNum,
          unit: "人",
        },
        {
          name: "实际触达人数：",
          value: data.sendNum,
          unit: "人",
        },
        {
          name: "触达率：",
          value: data.rate,
          unit: "%",
        },
      ];

      // 流量分析
      var accessResponseMap = [
        {
          name: "短链点击PV：",
          value: data.pv,
          unit: "次",
        },
        {
          name: "短链访点击UV：",
          value: data.uv,
          unit: "人",
        },
        {
          name: "商品详情页PV：",
          value: data.skuPvNum,
          unit: "",
        },
        {
          name: "商品详情页UV：",
          value: data.skuUvNum,
          unit: "",
        },
        {
          name: "店铺首页PV：",
          value: data.shopPvNum,
          unit: "",
        },
        {
          name: "店铺首页UV：",
          value: data.shopUvNum,
          unit: "",
        },
      ];
      // 下单分析
      var takeOrderMap = [
        {
          name: "下单转化率：",
          value: data.orderRate,
          unit: "%",
        },
        {
          name: "下单人数：",
          value: data.ordPins,
          unit: "人",
        },
        {
          name: "下单金额：",
          value: data.ordAmount,
          unit: "元",
        },
        {
          name: "下单订单数：",
          value: data.ordNum,
          unit: "单",
        },
        {
          name: "下单件数：",
          value: data.ordQtty,
          unit: "件",
        },
      ];
      // 付款分析
      var payMap = [
        {
          name: "下单-付款转化率：",
          value: data.orderPayRate,
          unit: "%",
        },
        {
          name: "付款转化率：",
          value: data.payRate,
          unit: "%",
        },
        {
          name: "付款人数：",
          value: data.payPins,
          unit: "人",
        },
        {
          name: "付款金额：",
          value: data.payAmount,
          unit: "元",
        },
        {
          name: "付款订单数：",
          value: data.payNum,
          unit: "单",
        },
        {
          name: "付款件数：",
          value: data.payQtty,
          unit: "件",
        },
        {
          name: "客单价：",
          value: data.perCustomerTransaction,
          unit: "元",
        },
      ];
      // 兴趣分析
      var successMap = [
        {
          name: "关注商品人数：",
          value: data.followSkuNum,
          unit: "人",
        },
        {
          name: "关注店铺人数：",
          value: data.followShopNum,
          unit: "人",
        },
        {
          name: "加购人数：",
          value: data.cartNum,
          unit: "人",
        },
      ];
      // 会员购买分析
      var marketingInsightIntoMap = [
        {
          name: "已购会员购买客户数：",
          value: data.memberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买客户数：",
          value: data.brandMemberBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买客户数：",
          value: data.cardMemberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买新客户数：",
          value: data.brandMemberNewBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买新用户数：",
          value: data.cardMemberNewBuyPins,
          unit: "人",
        },
      ];
      var shopMemberType = this.shopMemberType;

      if (shopMemberType == "2" || shopMemberType == "4") {
        marketingInsightIntoMap.splice(1, 1);
        marketingInsightIntoMap.splice(2, 1);
      } else if (shopMemberType == "3") {
        marketingInsightIntoMap.splice(2, 1);
        marketingInsightIntoMap.splice(3, 1);
      }

      var effectList = [
        {
          title: "触达分析",
          dataList: targetCustomerMap,
        },
        {
          title: "流量分析",
          dataList: accessResponseMap,
        },
        {
          title: "下单分析",
          dataList: takeOrderMap,
        },
        {
          title: "付款分析",
          dataList: payMap,
        },
        {
          title: "兴趣分析",
          dataList: successMap,
        },
        {
          title: "会员购买分析",
          dataList: marketingInsightIntoMap,
        },
      ];
      this.effectList = effectList;
    },

    reset() {},
    handleClick(tab, event) {},
    handleSearch() {
      this.getEffectData();
    },
    handleClose() {
      this.viewVisible = false;
    },
    clearTime() {},
    switchBean(index) {
      this.beanType = index;
    },
    // 列表排序
    selectChange(value) {
      this.$refs.goodsTable.sort(value,'descending');
    },
  },
  components: {
    echarts,
    generate
  },
};
</script>

<style lang="scss" scoped>
.title-line {
  border-left: 3px solid #fe4d45;
  padding-left: 8px;
  line-height: 20px;
}
.dialog-box {
  .effect-content {
    .effect-item {
      display: inline-block;
      vertical-align: text-top;
      width: 250px;
      border: 1px solid #eee;
      margin-right: 19px;
      margin-bottom: 20px;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        background: #fafafa;
        text-align: center;
        line-height: 50px;
      }
      .content {
        height: 233px;
        box-sizing: border-box;
        padding: 16px 19px;
        font-size: 14px;
        color: #333;
        line-height: 25px;
      }
    }
  }
  .trend-analysis {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-top: 32px;
    margin-bottom: 10px;
     .trend-wrap{
        margin-top: 23px;
        border: 1px solid #eee;
      }  
      .trend-box-x {
        border-radius: 4px 4px 0 0;
        background: #fafafa;
        font-size: 14px;
        color: #333;
        padding: 32px 40px;
        .trend-item {
          margin-bottom: 16px;
          &:last-child {
            margin-bottom: 0;
          }
          .type-title {
            font-weight: bold;
            display: inline-block;
            width: 80px;
            vertical-align: text-top;
          }
          .trend-radio {
            display: inline-block;
            width: calc(100% - 80px);
            vertical-align: text-top;
            /deep/.el-radio__label {
              font-size: 14px;
            }
            /deep/.el-radio {
              margin-bottom: 5px;
            }
          }
        }
      }

    .trend-box {
      background: #fafafa;
      margin-top: 17px;
      padding: 22px 45px;
      .trend-tab {
        background: #eeeeee;
        display: inline-block;
        padding: 5px;
        .trend-item {
          cursor: pointer;
          width: 96px;
          height: 28px;
          line-height: 28px;
          font-size: 14px;
          color: #666;
          display: inline-block;
          text-align: center;
          &.active {
            background: #fff;
            color: #fe4d45;
          }
        }
      }
    }
  }
  .goods-box {
    & > div {
      display: inline-block;
      margin-left: 8px;
    }
    img {
      width: 38px;
      height: 38px;
    }
    .shop-title {
      font-size: 14px;
      color: #666;
      width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .sku-line {
      color: #000;
      font-size: 14px;
      width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.tip-box {
  display: inline-block;
  padding-left: 12px;
  padding-right: 12px;
  text-align: left;
  // line-height: 21px;
  font-size: 14px;
  // margin-top: 12px;
  color: #999999;
  background: #fffaee;
  // position: relative;
  // margin: 20px 0 16px 0;
  border-radius: 28px;
  line-height: 28px;
  height: 28px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // span{
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // }
  .warning-icon {
    color: #ffb95e;
    font-size: 14px;
    // position: absolute;
    left: 5px;
    top: 7px;
  }
}

.form-tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-bottom: 16px;
  color: #999999;
  background: #fffaee;
  position: relative;
  line-height: 42px;

  &-icon{
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 14px 4px 0 3px;
  }
}
</style>